var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      attrs: {
        height: "24px",
        viewBox: "0 0 24 24",
        width: "24px",
        xmlns: "http://www.w3.org/2000/svg",
      },
    },
    [
      _c("path", {
        staticClass: "cls-1",
        attrs: {
          id: "coupon-Filled-2",
          d: "M21,10.5h.5V9A4.513,4.513,0,0,0,17,4.5h-.5A.5.5,0,0,0,16,5V7a1,1,0,0,1-2,0V5a.5.5,0,0,0-.5-.5H7A4.513,4.513,0,0,0,2.5,9v1.5H3a1.5,1.5,0,0,1,0,3H2.5V15A4.513,4.513,0,0,0,7,19.5h6.5A.5.5,0,0,0,14,19V17a1,1,0,0,1,2,0v2a.5.5,0,0,0,.5.5H17A4.513,4.513,0,0,0,21.5,15V13.5H21a1.5,1.5,0,0,1,0-3Zm-5,3a1,1,0,0,1-2,0v-3a1,1,0,0,1,2,0Z",
          "data-name": "coupon-Filled",
        },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }